import Cookies from "js-cookie";


export class CookieUtils {
    private static EXPIRATION_DAYS = 7;

    private static getOptions() {
        const options: Cookies.CookieAttributes = {
            expires: this.EXPIRATION_DAYS,
            path: '/',
            secure: true,
            sameSite: "Lax",
        };

        return options;
    }

    public static setCookie(name: string, value: string) {
        Cookies.set(name, value, this.getOptions());
    }

    public static getCookie(name: string): string | undefined {
        return Cookies.get(name);
    }

    public static removeCookie(name: string) {
        Cookies.remove(name);
    }
}